import {
  BadgeDollarSign,
  BadgeX,
  CreditCard,
  Timer,
  Undo2,
  CircleCheck,
  CircleX,
  CheckCircle,
  Truck,
  BatteryWarning,
  BatteryLow,
  BatteryMedium,
  BatteryFull,
  Battery,
  FolderTree,
  BriefcaseBusiness,
  ChartColumnStacked,
  ChartLine,
  ClipboardList,
  Home,
  Megaphone,
  PackageX,
  ShoppingBag,
  ShoppingCart,
  Users,
  OctagonX,
  MoveRight,
  TrendingUp,
  TrendingDown,
  BadgeCheck,
} from "lucide-react";

export const dashboardNavItems = [
  {
    title: "",
    items: [
      {
        icon: Home,
        title: "Dashboard",
        url: "/dashboard",
        permissions: ["admin"],
      },
    ],
  },
  {
    title: "Inventaire",
    items: [
      {
        icon: FolderTree,
        title: "Catégories",
        url: "/dashboard/categories",
        permissions: ["admin"],
      },
      {
        icon: ShoppingBag,
        title: "Produits",
        url: "/dashboard/products",
        permissions: ["admin"],
      },
    ],
  },
  {
    title: "Gestion du stock",
    items: [
      {
        icon: ChartColumnStacked,
        title: "Vue globale stock",
        url: "/dashboard/stock-overview",
        permissions: ["admin"],
      },
      {
        icon: BriefcaseBusiness,
        title: "Fournisseurs",
        url: "/dashboard/suppliers",
        permissions: ["admin"],
      },
      {
        icon: ShoppingCart,
        title: "Achats",
        url: "/dashboard/purchases",
        permissions: ["admin"],
      },
      {
        icon: PackageX,
        title: "Pertes",
        url: "/dashboard/losses",
        permissions: ["admin"],
      },
    ],
  },
  {
    title: "Commandes & livraisons",
    items: [
      {
        icon: ClipboardList,
        title: "Commandes",
        url: "/dashboard/orders",
        permissions: ["admin"],
      },
      {
        icon: Truck,
        title: "Tarifs livraison",
        url: "/dashboard/delivery",
        permissions: ["admin"],
      },
    ],
  },

  {
    title: "Administration",
    items: [
      {
        icon: ChartLine,
        title: "Statistiques annuelles",
        url: "/dashboard/annual-stats",
        permissions: ["admin"],
      },
      {
        icon: Megaphone,
        title: "Annonces",
        url: "/dashboard/annoucements",
        permissions: ["admin"],
      },
      {
        icon: Users,
        title: "Utilisateurs",
        url: "/dashboard/users",
        permissions: ["admin"],
      },
    ],
  },
];
export const userRoles = ["admin", "employe"];

export const discountTypes = ["none", "discount", "sale", "gift"];

export const productLabels = ["gift", "sale", "discount"];

export const margins = [
  {
    id: "none",
    icon: MoveRight,
    colors: {
      text: "text-stone-500",
      bg: "bg-stone-50 dark:bg-stone-500/20",
      border: "border-stone-400",
    },
  },
  {
    id: "high",
    icon: TrendingUp,
    colors: {
      text: "text-emerald-500",
      bg: "bg-emerald-50 dark:bg-emerald-500/20",
      border: "border-emerald-400",
    },
  },
  {
    id: "mid",
    icon: TrendingUp,
    colors: {
      text: "text-amber-500",
      bg: "bg-amber-50 dark:bg-amber-500/20",
      border: "border-amber-400",
    },
  },
  {
    id: "low",
    icon: TrendingDown,
    colors: {
      text: "text-red-500",
      bg: "bg-red-50 dark:bg-red-500/20",
      border: "border-red-400",
    },
  },
];

export const deliveryTypes = [
  {
    id: "home",
    name: "À domicile",
    colors: {
      text: "text-teal-500",
      bg: "bg-teal-50 dark:bg-teal-500/20",
      border: "border-teal-500",
    },
  },
  {
    id: "point",
    name: "Point relais",
    colors: {
      text: "text-blue-500",
      bg: "bg-blue-50 dark:bg-blue-500/20",
      border: "border-blue-500",
    },
  },
];

export const lossTypes = [
  {
    id: "damaged",
    name: "Dommages",
    color: {
      text: "text-red-500",
      bg: "bg-red-50 dark:bg-red-500/20",
      border: "border-red-500",
      hsl: "0 84.2% 60.2%",
    },
  },
  {
    id: "expired",
    name: "Expiré/Obsolète",
    color: {
      text: "text-teal-500",
      bg: "bg-teal-50 dark:bg-teal-500/20",
      border: "border-teal-500",
      hsl: "173.4 80.4% 40%",
    },
  },
  {
    id: "theft",
    name: "Vol/Perte",
    color: {
      text: "text-yellow-500",
      bg: "bg-yellow-50 dark:bg-yellow-500/20",
      border: "border-yellow-500",
      hsl: "45.4 93.4% 47.5%",
    },
  },
  {
    id: "defective",
    name: "Défectueux",
    color: {
      text: "text-blue-500",
      bg: "bg-blue-50 dark:bg-blue-500/20",
      border: "border-blue-500",
      hsl: "217.2 91.2% 59.8%",
    },
  },
  {
    id: "administrative",
    name: "Erreur Administrative",
    color: {
      text: "text-green-500",
      bg: "bg-green-50 dark:bg-green-500/20",
      border: "border-green-500",
      hsl: "142.1 70.6% 45.3%",
    },
  },
  {
    id: "natural",
    name: "Causes Naturelles",
    color: {
      text: "text-orange-500",
      bg: "bg-orange-50 dark:bg-orange-500/20",
      border: "border-orange-500",
      hsl: "24.6 95% 53.1%",
    },
  },
  {
    id: "other",
    name: "Autre",
    color: {
      text: "text-stone-500",
      bg: "bg-stone-50 dark:bg-stone-500/20",
      border: "border-stone-500",
      hsl: "25 5.3% 44.7%",
    },
  },
];

export const purchasesTypes = [
  {
    id: 1,
    name: "Achat",
    icon: CreditCard,
    color: {
      text: "text-green-500",
      bg: "bg-green-50 dark:bg-green-500/20",
      border: "border-green-500",
    },
  },
  {
    id: -1,
    name: "Retour",
    icon: Undo2,
    color: {
      text: "text-orange-500",
      bg: "bg-orange-50 dark:bg-orange-500/20",
      border: "border-orange-500",
    },
  },
];

export const operationTypes = [
  {
    id: "Achat",
    name: "Achat",
    icon: CreditCard,
    color: {
      text: "text-amber-500",
      bg: "bg-amber-50 dark:bg-amber-500/20",
      border: "border-amber-500",
    },
  },
  {
    id: "Retour Client",
    name: "Retour client",
    icon: Undo2,
    color: {
      text: "text-lime-500",
      bg: "bg-lime-50 dark:bg-lime-500/20",
      border: "border-lime-500",
    },
  },
  {
    id: "Vente",
    name: "Vente",
    icon: BadgeDollarSign,
    color: {
      text: "text-green-500",
      bg: "bg-green-50 dark:bg-green-500/20",
      border: "border-green-500",
    },
  },
  {
    id: "Retour Fournisseur",
    name: "Retour fournisseur",
    icon: Undo2,
    color: {
      text: "text-orange-500",
      bg: "bg-orange-50 dark:bg-orange-500/20",
      border: "border-orange-500",
    },
  },
  {
    id: "Perte",
    name: "Perte",
    icon: BadgeX,
    color: {
      text: "text-red-500",
      bg: "bg-red-50 dark:bg-red-500/20",
      border: "border-red-500",
    },
  },
];

export const stockStatuses = [
  {
    id: "none",
    name: "Indéterminé",
    icon: OctagonX,
    colors: {
      text: "text-stone-500",
      bg: "bg-stone-50 dark:bg-stone-500/20",
      border: "border-stone-400",
    },
  },
  {
    id: "out",
    name: "Rupture",
    icon: BatteryWarning,
    colors: {
      text: "text-red-500",
      bg: "bg-red-50 dark:bg-red-500/20",
      border: "border-red-400",
    },
  },
  {
    id: "vlow",
    name: "Trés bas",
    icon: Battery,
    colors: {
      text: "text-orange-500",
      bg: "bg-orange-50 dark:bg-orange-500/20",
      border: "border-orange-400",
    },
  },
  {
    id: "low",
    name: "Bas",
    icon: BatteryLow,
    colors: {
      text: "text-yellow-500",
      bg: "bg-yellow-50 dark:bg-yellow-500/20",
      border: "border-yellow-400",
    },
  },
  {
    id: "medium",
    name: "Moyen",
    icon: BatteryMedium,
    colors: {
      text: "text-lime-500",
      bg: "bg-lime-50 dark:bg-lime-500/20",
      border: "border-lime-400",
    },
  },
  {
    id: "high",
    name: "Élevé",
    icon: BatteryFull,
    colors: {
      text: "text-emerald-500",
      bg: "bg-emerald-50 dark:bg-emerald-500/20",
      border: "border-emerald-400",
    },
  },
];

export const orderStatuses = [
  {
    id: "in progress",
    name: "En traitement",
    icon: Timer,
    colors: {
      text: "text-amber-500",
      bg: "bg-amber-50 dark:bg-amber-500/20",
      border: "border-amber-500",
      fill: "fill-amber-100 dark:fill-amber-500/20",
      stroke: "stroke-amber-400",
    },
  },
  {
    id: "confirmed",
    name: "Confirmée",
    icon: CheckCircle,
    colors: {
      text: "text-sky-500",
      bg: "bg-sky-50 dark:bg-sky-500/20",
      border: "border-sky-500",
      fill: "fill-sky-100 dark:fill-sky-500/20",
      stroke: "stroke-sky-400",
    },
  },
  {
    id: "in shipping",
    name: "En livraison",
    icon: Truck,
    colors: {
      text: "text-lime-500",
      bg: "bg-lime-50 dark:bg-lime-500/20",
      border: "border-lime-500",
      fill: "fill-lime-100 dark:fill-lime-500/20",
      stroke: "stroke-lime-400",
    },
  },
  {
    id: "done",
    name: "Livrée",
    icon: CircleCheck,
    colors: {
      text: "text-emerald-500",
      bg: "bg-emerald-50 dark:bg-emerald-500/20",
      border: "border-emerald-500",
      fill: "fill-emerald-100 dark:fill-emerald-500/20",
      stroke: "stroke-emerald-400",
    },
  },
  {
    id: "canceled",
    name: "Annulée",
    icon: CircleX,
    colors: {
      text: "text-gray-500",
      bg: "bg-gray-50 dark:bg-gray-500/20",
      border: "border-gray-500",
      fill: "fill-gray-100 dark:fill-gray-500/20",
      stroke: "stroke-gray-400",
    },
  },
  {
    id: "return",
    name: "Retour",
    icon: Undo2,
    colors: {
      text: "text-red-500",
      bg: "bg-red-50 dark:bg-red-500/20",
      border: "border-red-500",
      fill: "fill-red-100 dark:fill-red-500/20",
      stroke: "stroke-red-400",
    },
  },
  {
    id: "partial return",
    name: "Retour partiel",
    icon: Undo2,
    colors: {
      text: "text-red-500",
      bg: "bg-red-50 dark:bg-red-500/20",
      border: "border-red-500",
      fill: "fill-red-100 dark:fill-red-500/20",
      stroke: "stroke-red-400",
    },
  },
];

export const months = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];

export const wilayaStatuses = [
  {
    id: false,
    icon: BadgeX,
    name: "Inactif",
    colors: {
      text: "text-red-500",
      bg: "bg-red-50 dark:bg-red-500/20",
      border: "border-red-400",
    },
  },
  {
    id: true,
    icon: BadgeCheck,
    name: "Actif",
    colors: {
      text: "text-emerald-500",
      bg: "bg-emerald-50 dark:bg-emerald-500/20",
      border: "border-emerald-400",
    },
  },
];

export const wilayas = [
  { id_wilaya: 1, wilaya_name: "Adrar" },
  { id_wilaya: 2, wilaya_name: "Chlef" },
  { id_wilaya: 3, wilaya_name: "Laghouat" },
  { id_wilaya: 4, wilaya_name: "Oum El Bouaghi" },
  { id_wilaya: 5, wilaya_name: "Batna" },
  { id_wilaya: 6, wilaya_name: "Béjaïa" },
  { id_wilaya: 7, wilaya_name: "Biskra" },
  { id_wilaya: 8, wilaya_name: "Béchar" },
  { id_wilaya: 9, wilaya_name: "Blida" },
  { id_wilaya: 10, wilaya_name: "Bouira" },
  { id_wilaya: 11, wilaya_name: "Tamanrasset" },
  { id_wilaya: 12, wilaya_name: "Tébessa" },
  { id_wilaya: 13, wilaya_name: "Tlemcen" },
  { id_wilaya: 14, wilaya_name: "Tiaret" },
  { id_wilaya: 15, wilaya_name: "Tizi Ouzou" },
  { id_wilaya: 16, wilaya_name: "Alger" },
  { id_wilaya: 17, wilaya_name: "Djelfa" },
  { id_wilaya: 18, wilaya_name: "Jijel" },
  { id_wilaya: 19, wilaya_name: "Sétif" },
  { id_wilaya: 20, wilaya_name: "Saïda" },
  { id_wilaya: 21, wilaya_name: "Skikda" },
  { id_wilaya: 22, wilaya_name: "Sidi Bel Abbès" },
  { id_wilaya: 23, wilaya_name: "Annaba" },
  { id_wilaya: 24, wilaya_name: "Guelma" },
  { id_wilaya: 25, wilaya_name: "Constantine" },
  { id_wilaya: 26, wilaya_name: "Médéa" },
  { id_wilaya: 27, wilaya_name: "Mostaganem" },
  { id_wilaya: 28, wilaya_name: "M'Sila" },
  { id_wilaya: 29, wilaya_name: "Mascara" },
  { id_wilaya: 30, wilaya_name: "Ouargla" },
  { id_wilaya: 31, wilaya_name: "Oran" },
  { id_wilaya: 32, wilaya_name: "El Bayadh" },
  { id_wilaya: 33, wilaya_name: "Illizi" },
  { id_wilaya: 34, wilaya_name: "Bordj Bou Arreridj" },
  { id_wilaya: 35, wilaya_name: "Boumerdès" },
  { id_wilaya: 36, wilaya_name: "El Tarf" },
  { id_wilaya: 37, wilaya_name: "Tindouf" },
  { id_wilaya: 38, wilaya_name: "Tissemsilt" },
  { id_wilaya: 39, wilaya_name: "El Oued" },
  { id_wilaya: 40, wilaya_name: "Khenchela" },
  { id_wilaya: 41, wilaya_name: "Souk Ahras" },
  { id_wilaya: 42, wilaya_name: "Tipaza" },
  { id_wilaya: 43, wilaya_name: "Mila" },
  { id_wilaya: 44, wilaya_name: "Aïn Defla" },
  { id_wilaya: 45, wilaya_name: "Naâma" },
  { id_wilaya: 46, wilaya_name: "Aïn Témouchent" },
  { id_wilaya: 47, wilaya_name: "Ghardaïa" },
  { id_wilaya: 48, wilaya_name: "Relizane" },
  { id_wilaya: 49, wilaya_name: "El M'ghair" },
  { id_wilaya: 50, wilaya_name: "El Menia" },
  { id_wilaya: 51, wilaya_name: "Ouled Djellal" },
  { id_wilaya: 52, wilaya_name: "Bordj Baji Mokhtar" },
  { id_wilaya: 53, wilaya_name: "Béni Abbès" },
  { id_wilaya: 54, wilaya_name: "Timimoun" },
  { id_wilaya: 55, wilaya_name: "Touggourt" },
  { id_wilaya: 56, wilaya_name: "Djanet" },
  { id_wilaya: 57, wilaya_name: "In Salah" },
  { id_wilaya: 58, wilaya_name: "In Guezzam" },
];
